<template>
  <v-dialog v-model="value" persistent width="500px">
    <v-card class="w-100 rounded-lg">
      <v-card-title style="word-break: break-word">
        {{ $t('spedilink.persons.deleteTitle') }}
      </v-card-title>
      <v-card-text class="text-subtitle-1 font-weight-regular">
        {{ $t('spedilink.persons.deleteMessage') }}
        <strong>{{ person.firstName }} {{ person.lastName }}</strong>?
        <div class="mt-2 grey--text text-body-2">
          {{ $t('spedilink.persons.deleteWarning') }}
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn outlined :disabled="loading" @click="close()">
          {{ $t('common.no') }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-2"
          :loading="loading"
          :disabled="loading"
          @click="remove()"
        >
          {{ $t('common.yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from '@/services'

export default {
  name: 'DeleteSpediLinkPersonDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    person: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async remove () {
      this.loading = true
      try {
        await Service.delete(`spedilink/SpediLinkUsers/Delete/${this.person.id}`)
        await this.$store.dispatch('setSuccessNotification', this.$t('common.confirmOperation'))
        this.$emit('person-deleted')
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
